import { Box, Button } from '@rsos/components/capstone/base';
import {
  Label,
  ButtonContainer,
} from '../AirAmbulanceForm/AirAmbulanceFormStandalone.styles';
import { RadioButtonTitle } from '../AirAmbulanceForm/components/RequestSection.styles';
import type { SelectOption } from '../types';

interface LabeledButtonGroupProps {
  label: string;
  options: string[];
  selectedValue: string | SelectOption;
  onSelect?: (option: string) => void;
  disabled?: boolean;
  title?: string;
}

/**
 * The labeled button group component used in the Air Ambulance Edit Form.
 */
export function LabeledButtonGroup({
  label,
  options,
  selectedValue,
  onSelect,
  disabled,
  title,
}: LabeledButtonGroupProps): JSX.Element {
  return (
    <Box pb={4} title={title}>
      <Label isDisabled={disabled}>
        <RadioButtonTitle size="small">{label}</RadioButtonTitle>
      </Label>
      <ButtonContainer horizontal>
        {options.map((option: string) => (
          <Button
            key={option}
            type="button"
            btnType={selectedValue === option ? 'primary' : 'tertiary'}
            onClick={onSelect ? () => onSelect(option) : undefined}
            grow
            disabled={disabled}
          >
            {option}
          </Button>
        ))}
      </ButtonContainer>
    </Box>
  );
}
